import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ContactService } from '../../services/contact.service';


@Component({
    selector: 'contact-unsubscribe',
    templateUrl: './contact-unsubscribe.component.html',
    standalone: false
})
export class ContactUnsubscribeComponent implements OnInit {
    private encryptedContactId: string = '';
    public unsubscribedSuccessfully: boolean = false;
    public message: string = '';

    constructor(public contactService: ContactService, route: ActivatedRoute, private titleService: Title) {
        route.params.subscribe(params => { this.encryptedContactId = params.contactId });
        this.titleService.setTitle('Unsubsribe');
    }

    ngOnInit() {
        this.contactService.unsubscribeContactByEncryptedId(this.encryptedContactId).subscribe(result => {
            if (result.resultCollection.length > 0) {
                this.unsubscribedSuccessfully = true;
                this.message = "You have unsubscribed from Offer emails";
            }
            else {
                this.unsubscribedSuccessfully = false;
                this.message = "Failed to unsubscribe from Offer emails.  Please contact ALS.";
            }
        });
    }
}
